import { RECEIVED_HEADER_STATE } from '../actions/header-actions';

const initialState = {
  isModalOpen: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case RECEIVED_HEADER_STATE:
      return {
        isModalOpen: action.isModalOpen,
      };
    default:
      return state;
  }
}

// export function getHeaderModal(state) {
//   return state.headerStore.get('isModalOpen')
// }
